import { endpoints, request } from '!core/api';

export const disclaimersServices = {
  getDisclaimer: ({
    context,
    operationType,
    symbol,
    exchange,
    securityType,
  }) => {
    const symbolParamQString = symbol ? `&symbol=${symbol}` : '';
    const exchangeParamQString = exchange ? `&exchange=${exchange}` : '';
    const securityTypeParamQString = securityType
      ? `&securityType=${securityType}`
      : '';

    return request.get(
      endpoints.chnn(
        `wsbGetDiscalimers?context=${context}&operationType=${operationType}${symbolParamQString}${exchangeParamQString}${securityTypeParamQString}`,
      ),
    );
  },
  getDisclaimerNoAuth: ({ context }) =>
    request.get(endpoints.chnn(`wsbGetDisclaimersNoAuth?context=${context}`)),
};
